import { DrawerForm, DrawerSizeEnum } from '@acceso/design-system';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputArea } from '@/components/FormFields/InputArea';
import { SelectForm } from '@/components/FormFields/SelectForm';
import { REVIEW_INCIDENCE_TYPES } from '@/constants';
import { useReport } from '@/stores/report-store';
import { EReviewIncidenceType } from '@/types';

import { TReportDrawerForm } from './types';

export type TProgramDrawerFormProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: TReportDrawerForm) => void;
};

const defaultValues: TReportDrawerForm = {
  type: EReviewIncidenceType.OTHERS,
  description: '',
};

export const ReportDrawer = ({ isOpen, onClose, onSubmit }: TProgramDrawerFormProps) => {
  const { t } = useTranslation();
  const { reportEditData } = useReport();
  const form = useForm<TReportDrawerForm>({
    mode: 'all',
    defaultValues,
  });

  useEffect(() => {
    if (reportEditData) {
      form.reset({
        description: reportEditData.review_incidence_note || '',
        type: reportEditData.review_incidence_type || EReviewIncidenceType.OTHERS,
      });
    }
  }, [reportEditData]);

  const handleSubmit = form.handleSubmit(data => {
    onSubmit(data);
    form.reset(defaultValues);
  });

  const handleClose = () => {
    form.reset(defaultValues);
    onClose();
  };

  return (
    <DrawerForm
      title={!reportEditData ? t('Crear nueva incidencia') : t('Editar incidencia')}
      isOpen={isOpen}
      onCancel={handleClose}
      onSubmit={handleSubmit}
      size={DrawerSizeEnum.MD}
      labels={{
        submit: t('Guardar'),
        cancel: t('Cancelar'),
      }}
    >
      <div className="flex w-full flex-col gap-5">
        <SelectForm
          options={REVIEW_INCIDENCE_TYPES}
          label={t('Tipo')}
          name="type"
          form={form}
          required
        />
        <InputArea label={t('Descripción')} name="description" form={form} />
      </div>
    </DrawerForm>
  );
};
